import axios from "axios"
import { API_URL, getHeader } from "../config"

export const getHighlight = async() => {
    const { data } = await axios.get(API_URL + `/api/highlight/AFGJI`);
    console.log(data)
    return data;
} 
export const getHighlightInner = async() => {
    const { data } = await axios.get(API_URL + `/api/highlight/all/AFGJI`);
    console.log(data)
    return data;
} 
export const getBirthdays = async() => {    
    const { data } = await axios.get(API_URL + `/api/birthdays/AFGJI`);
    return data;
} 
export const getNews = async() => {
    console.log("first")
    const { data } = await axios.get(API_URL + `/api/news/AFGJI`);
    console.log("news:",data)
    return data;
} 
export const getNewsInner = async() => {
    console.log("first")
    const { data } = await axios.get(API_URL + `/api/news/all/AFGJI`);
    console.log("news:",data)
    return data;
} 

export const getEvents = async() => {
    const { data } = await axios.get(API_URL + `/api/events/AFGJI`);
    console.log(data)
    return data;
} 

export const getEventsinner = async() => {
    const { data } = await axios.get(API_URL + `/api/events/All/AFGJI`);
    console.log(data)
    return data;
} 
 
export const getGallery = async(year = null) => {
    try {
        let url = API_URL + `/api/gallery/All/AFGJI`;
        if (year) {
            url += `?year=${year}`;
        }
        
        const { data } = await axios.get(url);
        console.log(data);
        return data;
    } catch (error) {
        console.error('Error fetching gallery:', error);
        throw error;
    }
}


export const getGalleryInnerSenior = async (schoolCode = 'AFGJI', year = "2025", category = "SeniorWing") => {
    let url = `${API_URL}/api/gallery/All/limit/${schoolCode}`;
    const params = new URLSearchParams();
  
    if (year && year !== 'All') {
      params.append('year', year);
    }
  
    // ✅ Normalize category to an array
    const categoryArray = Array.isArray(category) ? category : [category];
  
    categoryArray.forEach(cat => {
      if (cat && cat !== 'All') {
        params.append('category', cat);
      }
    });
  
    if ([...params].length > 0) {
      url += `?${params.toString()}`;
    }
  
    const { data } = await axios.get(url);
    return data;
  };
export const getGalleryInnerSpecialWing = async (schoolCode = 'AFGJI', year = "2025", category = "SpecialWing") => {
    let url = `${API_URL}/api/gallery/All/limit/${schoolCode}`;
    const params = new URLSearchParams();
  
    if (year && year !== 'All') {
      params.append('year', year);
    }
  
    // ✅ Normalize category to an array
    const categoryArray = Array.isArray(category) ? category : [category];
  
    categoryArray.forEach(cat => {
      if (cat && cat !== 'All') {
        params.append('category', cat);
      }
    });
  
    if ([...params].length > 0) {
      url += `?${params.toString()}`;
    }
  
    const { data } = await axios.get(url);
    return data;
  };

export const getGalleryInnerPrimary = async (schoolCode = 'AFGJI', year = "2025", category = "PrimaryWing") => {
    let url = `${API_URL}/api/gallery/All/limit/${schoolCode}`;
    const params = new URLSearchParams();
  
    if (year && year !== 'All') {
      params.append('year', year);
    }
  
    // ✅ Normalize category to an array
    const categoryArray = Array.isArray(category) ? category : [category];
  
    categoryArray.forEach(cat => {
      if (cat && cat !== 'All') {
        params.append('category', cat);
      }
    });
  
    if ([...params].length > 0) {
      url += `?${params.toString()}`;
    }
  
    const { data } = await axios.get(url);
    return data;
  };

export const getGalleryInner = async (schoolCode = 'AFGJI', year = "2025", category = "PhotoGallery") => {
    let url = `${API_URL}/api/gallery/All/limit/${schoolCode}`;
    const params = new URLSearchParams();
  
    if (year && year !== 'All') {
      params.append('year', year);
    }
  
    // ✅ Normalize category to an array
    const categoryArray = Array.isArray(category) ? category : [category];
  
    categoryArray.forEach(cat => {
      if (cat && cat !== 'All') {
        params.append('category', cat);
      }
    });
  
    if ([...params].length > 0) {
      url += `?${params.toString()}`;
    }
  
    const { data } = await axios.get(url);
    return data;
  };
  
  

  


export const getSubGallery = async(id) => {
    console.log(id)
    const { data } = await axios.get(API_URL + `/api/subGallery?id=${id}`);
    console.log(data)
    return data;
} 

export const getNotification = async() => {
    const { data } = await axios.get(API_URL + `/api/notification/AFGJI`,getHeader());
    console.log(data)
    return data;
} 

export const getTopper = async() => {
    const { data } = await axios.get(API_URL + `/api/topper/AFGJI`,getHeader());
    console.log(data)
    return data;
} 

export const getOnlineRegistration = async() => {
    const { data } = await axios.get(API_URL + `/api/onlineRegistration/AFGJI`,getHeader());
    console.log("online registration Data", data)
    return data;
} 

export const getSliders = async() => {
    const { data } = await axios.get(API_URL + `/api/slider/AFGJI`,getHeader());
    return data;
}

export const getPrincipalMessage = async() => {
    const { data } = await axios.get(API_URL + `/api/principalMessage/AFGJI`, getHeader());
    return data;
} 

export const getMedia = async() => {
    const { data } = await axios.get(API_URL + `/api/media/AFGJI`, getHeader());
    console.log(data);
    return data;
} 
export const getVideoGallery = async() => {
    const { data } = await axios.get(API_URL + `/api/video/all/AFGJI`, getHeader());
    return data;
} 
export const getCircular = async() => {
    const { data } = await axios.get(API_URL + `/api/circular/all/AFGJI`, getHeader());
    console.log(data);
    return data;
} 
export const getReading = async() => {
    const { data } = await axios.get(API_URL + `/api/reading/all/AFGJI`, getHeader());
    console.log(data);
    return data;
} 
export const getTestimonial = async() => {
    const { data } = await axios.get(API_URL + `/api/testimonials/AFGJI`, getHeader());
    console.log(data);
    return data;
} 
export const getFaculty = async() => {
    const { data } = await axios.get(API_URL + `/api/faculty/all/AFGJI`, getHeader());
    console.log(data);
    return data;
} 

export const postTransferCertificate = async(name,admission) => {
    console.log(name,admission)

    const { data } = await axios.post(API_URL + `/api/tc/AFGJI`,{name,admission},getHeader());
    return data;
}


// export const form = async (formData, header) => {
//     try {
//         const { data } = await axios.post(`${API_URL}/api/form/LFSGV`, formData, header);
//         return data;
//     } catch (error) {
//         console.error('Error in form submission:', error);
//         if (error.response) {
//             console.error('Error response data:', error.response.data);
//             console.error('Error response status:', error.response.status);
//         }
//         throw error;
//     }
// };
